<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-11-04 09:41:54
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-11-11 11:16:57
-->

<template>
  <div class="OpenAccountSuccess">
    <CustomHead srcName="success.png">
      <h3>Ⅱ类电子账户开户成功</h3>
    </CustomHead>
    <div class="tip">
      <p style="margin-bottom: 80px;">
        此账号将作为您的放款及还款账户，请下载浦发
        银行手机APP，进行提现转账及还款操作！
      </p>
    </div>
    <List left="账户">
      <div class="List_copy">
        <div>{{ bankNo }}</div>
        <div
          class="List_copy_btn"
          @click="onSee"
        >查看</div>
      </div>
    </List>
    <List
      left="银行"
      right="浦发银行"
    />
    <Button
      :loading="this.$store.state.commonForms.Isloading"
      loadingText="提交中..."
      :text="draw"
      :type="danger"
      :disabled="this.$store.state.commonForms.Isloading"
      class="nextStep"
      :click="goToNextPage"
    />
    <server-bank
      :productId="this.$route.query.productId"
      :isRelative="true"
    ></server-bank>
  </div>
</template>

<script>
import Button from '@/components/Button.vue';
import CustomHead from '@/components/CustomHead.vue';
import ServerBank from '@/components/ServerBank.vue';
import List from '@/components/List.vue';
import { Toast } from 'vant';

export default {
  name: 'OpenAccountSuccess',

  data() {
    return {
      danger: 'danger',
      draw: '下一步',
      loading: false,
      canGoNext: false,
      voucher: '',
      bank: '',
      bankNo: '',
    };
  },

  components: {
    List,
    Button,
    CustomHead,
    ServerBank
  },

  mounted() {
    this.$api.PublicPage.getHideAccount({
      orderId: this.$router.currentRoute.query.orderId,
    }).then((res) => {
      if (res.success) {
        this.bankNo = res.data.classTwoCard;
      } else {
        Toast(res.returnMessage);
      }
    });
  },

  methods: {
    onSee() {
      this.$api.PublicPage.getSuccessfulLink({
        orderId: this.$router.currentRoute.query.orderId,
      }).then((res) => {
        if (res.success) {
          window.location.href = res.data.successful_link;
        } else {
          Toast(res.returnMessage);
        }
      });
    },
    goToNextPage() {
      this.$store.dispatch('commonForms/nextJumpPage', {
        orderId:
          this.$router.currentRoute.query.orderId
          || localStorage.getItem('orderId'),
      });
    },
  },
};
</script>
<style scoped>
.tip {
  box-sizing: border-box;
  padding: 0 20px 0 20px;
  color: rgba(128, 128, 128, 1);
  font-size: 13px;
  text-align: left;
}
.tip p {
  text-align: center;
}
.nextStep {
  padding-top: 100px;
}
.copy {
  position: absolute;
  bottom: -10px;
  right: 1px;
}
.handeCopy {
  width: 60px;
  height: 20px;
  line-height: 20px;
  display: flex;
  justify-items: center;
  align-items: center;
  border: 1px solid #f56446;
  font-size: 12px;
  color: #f56446;
  flex-direction: column;
  border-radius: 4px;
}
.List_copy {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  color: #495060;
}
.List_copy_btn {
  margin-left: 8px;
  color: #ff6538;
}
</style>
